import { isBreakingSpace } from '../textMetricsHelpers';
import { CanvasTextMetricList } from './CanvasTextMetricList';
import type { CanvasWordElementMetrics } from './CanvasWordElementMetrics';

export class CanvasHighlightSpanMetrics extends CanvasTextMetricList<CanvasWordElementMetrics> {
    override _getSourceWordReferenceIndices(): never[] {
        // could support if needed, just have to de-duplicate the indices from the word elements but don't need this right now
        throw new Error(
            'CanvasHighlightSpanMetrics does not support getSourceWordReferenceIndices',
        );
    }

    get elements(): CanvasWordElementMetrics[] {
        return this.children;
    }

    get visibleWords(): CanvasWordElementMetrics[] {
        return this.children.filter((child) => !isBreakingSpace(child.text));
    }
}
